import { Skeleton, Grid, Group } from "@mantine/core";
import { useContext, useEffect } from "react";
import { AppContext } from "src/api/AppContext";
import { GetOrganizationQuery } from "src/generated/graphql";
import { BasicForm } from "./components/BasicForm";
import { Sidebar } from "./components/Sidebar";
import { useMediaQuery } from "@mantine/hooks";

export type IOrgProps = {
  refetch: () => void;
  loading: boolean;
  organizationOne: GetOrganizationQuery["organizationOne"];
};

const OrganizationDetail = ({
  refetch,
  loading,
  organizationOne,
}: IOrgProps) => {
  const { setCurrentPageTitle } = useContext(AppContext);

  useEffect(() => {
    setCurrentPageTitle("Organization Details");

    return () => {
      setCurrentPageTitle(undefined);
    };
  }, []);

  const refetchOrganization = () => {
    refetch();
  };

  const desktopView = useMediaQuery("(min-width: 580px)");

  if (!loading && organizationOne) {
    return (
      <Group spacing={20} align="start" style={{ height: "100%" }}>
        <div style={{ flex: 1 }}>
          <BasicForm
            organizationData={organizationOne}
            refetch={refetchOrganization}
          />
        </div>
        <div
          style={{
            minWidth: 250,
            width: desktopView ? undefined : "100%",
            height: desktopView ? "100%" : undefined,
          }}
        >
          <Sidebar
            organizationData={organizationOne}
            refetch={refetchOrganization}
          />
        </div>
      </Group>
    );
  }
  return (
    <Grid mx={18}>
      <Grid.Col span={8}>
        <Skeleton height={50} circle mb="sm" />
        <Skeleton height={40} mt={8} radius="sm" />
        <Skeleton height={40} mt={8} radius="sm" />
      </Grid.Col>
      <Grid.Col span={4}>
        <Skeleton height={40} mt={{ lg: 75 }} radius="sm" />
        <Skeleton height={40} mt={8} radius="sm" />
        <Skeleton height={40} mt={8} radius="sm" />
      </Grid.Col>
    </Grid>
  );
};

export default OrganizationDetail;
